module.exports = __webpack_public_path__ + "img/shape-4@2x.63b6b5e9.png";